// @flow

import type { MenuLink } from '../types/MenuLink';
import hasFullAccess from './hasFullAccess';
import type { User } from '../types/User';

const filterPremiumLinks = (menuLink: MenuLink, user: User) => !(menuLink.hideWhenPremiumUser && hasFullAccess(user));

export default filterPremiumLinks;
